/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { visitorAdminControllerGetDeviceTypeV1 } from '../fn/visitor-admin/visitor-admin-controller-get-device-type-v-1';
import { VisitorAdminControllerGetDeviceTypeV1$Params } from '../fn/visitor-admin/visitor-admin-controller-get-device-type-v-1';
import { visitorAdminControllerGetIncomingPageV1 } from '../fn/visitor-admin/visitor-admin-controller-get-incoming-page-v-1';
import { VisitorAdminControllerGetIncomingPageV1$Params } from '../fn/visitor-admin/visitor-admin-controller-get-incoming-page-v-1';
import { visitorAdminControllerGetPopularPageV1 } from '../fn/visitor-admin/visitor-admin-controller-get-popular-page-v-1';
import { VisitorAdminControllerGetPopularPageV1$Params } from '../fn/visitor-admin/visitor-admin-controller-get-popular-page-v-1';
import { visitorAdminControllerGetTotalVisitorsV1 } from '../fn/visitor-admin/visitor-admin-controller-get-total-visitors-v-1';
import { VisitorAdminControllerGetTotalVisitorsV1$Params } from '../fn/visitor-admin/visitor-admin-controller-get-total-visitors-v-1';
import { visitorAdminControllerGetVisitorsV1 } from '../fn/visitor-admin/visitor-admin-controller-get-visitors-v-1';
import { VisitorAdminControllerGetVisitorsV1$Params } from '../fn/visitor-admin/visitor-admin-controller-get-visitors-v-1';
import { VisitorChartDataDto } from '../models/visitor-chart-data-dto';
import { VisitorDto } from '../models/visitor-dto';

@Injectable({ providedIn: 'root' })
export class VisitorAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `visitorAdminControllerGetVisitorsV1()` */
  static readonly VisitorAdminControllerGetVisitorsV1Path = '/api/v1/visitors/admin/search';

  /**
   * 방문자 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorAdminControllerGetVisitorsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetVisitorsV1$Response(params: VisitorAdminControllerGetVisitorsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = visitorAdminControllerGetVisitorsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 방문자 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorAdminControllerGetVisitorsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetVisitorsV1(params: VisitorAdminControllerGetVisitorsV1$Params, context?: HttpContext): Observable<{
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.visitorAdminControllerGetVisitorsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `visitorAdminControllerGetTotalVisitorsV1()` */
  static readonly VisitorAdminControllerGetTotalVisitorsV1Path = '/api/v1/visitors/admin/total-visit';

  /**
   * 총 방문자 수 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorAdminControllerGetTotalVisitorsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetTotalVisitorsV1$Response(params?: VisitorAdminControllerGetTotalVisitorsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorAdminControllerGetTotalVisitorsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 총 방문자 수 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorAdminControllerGetTotalVisitorsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetTotalVisitorsV1(params?: VisitorAdminControllerGetTotalVisitorsV1$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorAdminControllerGetTotalVisitorsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorAdminControllerGetPopularPageV1()` */
  static readonly VisitorAdminControllerGetPopularPageV1Path = '/api/v1/visitors/admin/popular-page';

  /**
   * 인기 페이지 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorAdminControllerGetPopularPageV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetPopularPageV1$Response(params?: VisitorAdminControllerGetPopularPageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorAdminControllerGetPopularPageV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인기 페이지 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorAdminControllerGetPopularPageV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetPopularPageV1(params?: VisitorAdminControllerGetPopularPageV1$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorAdminControllerGetPopularPageV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorAdminControllerGetIncomingPageV1()` */
  static readonly VisitorAdminControllerGetIncomingPageV1Path = '/api/v1/visitors/admin/incoming-page';

  /**
   * 유입 페이지 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorAdminControllerGetIncomingPageV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetIncomingPageV1$Response(params?: VisitorAdminControllerGetIncomingPageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorAdminControllerGetIncomingPageV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 유입 페이지 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorAdminControllerGetIncomingPageV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetIncomingPageV1(params?: VisitorAdminControllerGetIncomingPageV1$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorAdminControllerGetIncomingPageV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorAdminControllerGetDeviceTypeV1()` */
  static readonly VisitorAdminControllerGetDeviceTypeV1Path = '/api/v1/visitors/admin/device-type';

  /**
   * 총 방문자 수 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorAdminControllerGetDeviceTypeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetDeviceTypeV1$Response(params?: VisitorAdminControllerGetDeviceTypeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorAdminControllerGetDeviceTypeV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 총 방문자 수 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorAdminControllerGetDeviceTypeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorAdminControllerGetDeviceTypeV1(params?: VisitorAdminControllerGetDeviceTypeV1$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorAdminControllerGetDeviceTypeV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

}
